import { InsuranceProgramFragment } from '@websky/graphql';

const DATA_GROUP_NAME_ATTR = 'data-group-name';
const DATA_INSURANCE_TYPE_ATTR = 'data-insurance-type';

export const isAlwaysOpenInsurancePopup = (iataCode: string) => ['Y7'].includes(iataCode);

export function getInsuranceGroupNameAttr(groupName?: string) {
	if (!groupName) {
		return {};
	}

	return { [DATA_GROUP_NAME_ATTR]: groupName };
}

export const getInsuranceTypeAttr = (insurancePrograms?: InsuranceProgramFragment[]) => {
	if (!insurancePrograms?.length) {
		return {};
	}

	return { [DATA_INSURANCE_TYPE_ATTR]: insurancePrograms[0].type };
};
